/**
 * Persistent "Back to Home" navigation anchor.
 * Renders a circular outlined button with a sharp left-arrow SVG and a
 * 'Space Grotesk' 600/14px label in Deep Navy (#042C53).
 * On hover the circle fills with Medical Blue (#185FA5) and the arrow
 * stroke flips to pure white. The action breaks out of any portal route
 * loop and redirects the browser natively back to the public home page.
 */
export default function BackToHome() {
  const goHome = () => {
    // Native redirect — breaks out of in-portal SPA route state and lands
    // on the public website home page.
    window.location.href = "/";
  };

  return (
    <button
      type="button"
      className="back-home"
      onClick={goHome}
      aria-label="Back to Home"
      data-testid="back-to-home-btn"
    >
      <span className="back-home-ic" aria-hidden="true">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
      </span>
      <span className="back-home-label">Back to Home</span>
    </button>
  );
}
